<div class="gb-dialog-header">
  <h1 translate="ITEMS.CATEGORY.CREATE_TITLE"></h1>
</div>
<div class="gb-dialog-content">
  <gb-edit-category
    #editCategoryComponent
    [markFormAsTouched]="markFormAsTouched"
    (itemsSelect)="selectItems($event)"
  ></gb-edit-category>
</div>

<div class="gb-flex-button-container gb-dialog-actions-container">
  <button mat-stroked-button translate="CANCEL" mat-dialog-close></button>
  <button [disabled]="(editCreateLoaded$ | async) === false" mat-flat-button (click)="submit()">
    <gb-button-loader [loaded$]="editCreateLoaded$">
      <span translate="ITEMS.CATEGORY.CREATE_SUBMIT"></span>
    </gb-button-loader>
  </button>
</div>
